var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2266 3.39124C6.88628 3.74456 5.01461 5.67745 4.73319 8.16169L4.4458 10.6987C4.37438 11.3291 4.11888 11.9224 3.71307 12.4C2.8519 13.4137 3.55084 15 4.85861 15H15.1417C16.4495 15 17.1484 13.4137 16.2873 12.4C15.8814 11.9224 15.6259 11.3292 15.5545 10.6987L15.3646 9.02228M12.5002 16.6667C12.1363 17.6377 11.1544 18.3333 10.0002 18.3333C8.84597 18.3333 7.86407 17.6377 7.50016 16.6667M16.6668 4.16667C16.6668 5.54738 15.5475 6.66667 14.1668 6.66667C12.7861 6.66667 11.6668 5.54738 11.6668 4.16667C11.6668 2.78595 12.7861 1.66667 14.1668 1.66667C15.5475 1.66667 16.6668 2.78595 16.6668 4.16667Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationHeaderIcon);
export default __webpack_public_path__ + "static/media/notification-header-icon.c29f9c99e475bd36cffa3f902c3e631b.svg";
export { ForwardRef as ReactComponent };